import { makeUseFormHook } from "./make-use-form-hook.js";
import { createFormContext } from "@mantine/form";

//#region src/hooks/form/create-form-context.ts
const createFormContext$1 = () => {
	const [Provider, useFormContext, useFormBase] = createFormContext();
	return [
		Provider,
		useFormContext,
		makeUseFormHook(useFormBase)
	];
};

//#endregion
export { createFormContext$1 as createFormContext };